import React, { useEffect, useState } from 'react';
import BlogPageCard from '@/components/blog/BlogPageCard';
import { PrimaryButton } from '@/components/common/PrimaryButton';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { BlogEnum } from '@/types/translations/BlogEnum';
import clsx from 'clsx';
import NoDataCard from '../common/NoDataCard';
import { BlogCardsGridProps } from '@/types/props/components/blogs';

export default function BlogCardsGrid({
  oneLine,
  blogs,
  blogsLoading,
  showAll = false,
  showAllButton = true,
}: BlogCardsGridProps) {
  const { translate } = useTypedTranslation<BlogEnum>('blog');

  const [showAllArticles, setShowAllArticles] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    if (showAllButton) {
      setShowButton(true);
    }
    if (showAll) {
      setShowAllArticles(true);
    }
  }, [showAll, showAllButton]);

  return (
    <>
      <div className={clsx('tw-flex tw-flex-col tw-gap-6')}>
        <div
          className={clsx({
            ['tw-hidden']: oneLine,
          })}
        >
          {blogsLoading === true ? (
            <BlogPageCard blog={null} mainCard={true} />
          ) : blogs.length <= 0 ? null : (
            <BlogPageCard blog={blogs[0]} mainCard={true} />
          )}
        </div>
        <div className="tw-flex tw-justify-between child:tw-basis-[calc(33.33%-1rem)] child:tw-w-[calc(33.33%-1rem)] tw-flex-wrap tw-gap-4 max-md:child:tw-basis-[calc(50%-1rem)] max-md:child:tw-w-[calc(50%-1rem)] max-sm:child:tw-basis-full">
          {blogsLoading === false && blogs.length === 0 && (
            <NoDataCard type="blog" />
          )}
          {blogsLoading === true
            ? Array.from({ length: 6 }).map((_, index) => (
                <BlogPageCard key={index} blog={null} />
              ))
            : blogs.length <= 0
              ? null
              : oneLine
                ? [...blogs]
                    .slice(0, showAllArticles ? blogs.length : 3)
                    .map((blog) => <BlogPageCard key={blog.id} blog={blog} />)
                : [...blogs]
                    .slice(1, showAllArticles ? blogs.length : 7)
                    .map((blog) => <BlogPageCard key={blog.id} blog={blog} />)}
        </div>
      </div>
      {showButton && (
        <div className="tw-flex tw-items-center tw-justify-center tw-mt-12">
          <PrimaryButton
            type="button"
            outlined={true}
            className="tw-font-bold tw-px-16 tw-text-lg"
            onClick={() => setShowAllArticles((prev) => !prev)}
          >
            {showAllArticles
              ? translate(BlogEnum.less_articles)
              : translate(BlogEnum.all_articles)}
          </PrimaryButton>
        </div>
      )}
    </>
  );
}
